import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { customSWRConfig } from '../model/types';
import { isCustomerPage, isOrganizationPage, isTicketsPage } from '../utils/routeHelper';
import useCurrentTicket from './ticketDetailPage/useCurrentTicket';
import useCurrentOrganization from './useCurrentOrganization';
import useCurrentUser from './useCurrentUser';
import { deriveCustomizedDetailedUser } from './useUserById';

export default function useCurrentTabData(config: customSWRConfig = {}) {
    const { asPath } = useRouter();
    const { data: ticketTabData } = useCurrentTicket(config);
    const { data: userTabData } = useCurrentUser(config);
    const { data: organizationTabData } = useCurrentOrganization(config);

    return useMemo(
        () =>
            isOrganizationPage(asPath)
                ? organizationTabData
                : isTicketsPage(asPath)
                ? ticketTabData
                : isCustomerPage(asPath)
                ? deriveCustomizedDetailedUser(userTabData)
                : undefined,
        [asPath, organizationTabData, ticketTabData, userTabData]
    );
}
